import { render } from "./HourlyCorrectionsM.vue?vue&type=template&id=bbf316bc&scoped=true"
import script from "./HourlyCorrectionsM.vue?vue&type=script&lang=js"
export * from "./HourlyCorrectionsM.vue?vue&type=script&lang=js"

import "./HourlyCorrectionsM.vue?vue&type=style&index=0&id=bbf316bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf316bc"]])

export default __exports__